import angular from 'angular';

import inlineSalesEditUrl from './salesInlineEditComponent.html';

class InitialSalesEditCtrl {
  salesLoaded = false;
  isEditActive = false;

  constructor(focus, Utils, Authentication, $rootScope, $document, $element, $scope) {
    'ngInject';

    Object.assign(this, { focus, Utils, Authentication, $rootScope, $document, $element, $scope });
  }

  $onInit() {
    this.requiredSubscription = this.Authentication.user.orgSettings.premiumFeatures.laborCost;
    this.currencySymbol = this.$rootScope.currencySymbol;
    this.numberWithDecimalPattern = this.Utils.getNumberValidationPattern();

    this.$scope.$watch('ctrl.sale', () => {
      if (this.sale) {
        this._onSaleChange();
      }
    });

    this.$scope.$watch('ctrl.editedSale.default', () => {
      if (this.salesLoaded && !this.amount) {
        this.initialValue = this.editedSale.default;
      }
    });
  }

  $onDestroy() {
    this.$document.off('click', this._documentClickHandler);
  }

  get editedSale() {
    if (!this.salesLoaded) {
      return {};
    }

    // recognize dummy sale and create empty override
    if (!this.sale || !this.sale.type) {
      this.sale = this.getEmptySale();
    }

    return this.sale;
  }

  set editedSale(val) {
    this.sale = val;
  }

  get amount() {
    return this.editedSale.amount;
  }

  set amount(val) {
    this.editedSale.amount = val;
  }

  startEditMode() {
    if (this.inactive) {
      return;
    }

    this.isEditActive = true;
    this.focus('focus');
    this.$document.on('click', this._documentClickHandler);
  }

  cancel() {
    this.editedSale.amount = this.initialAmount;
    this._exitEditMode();
  }

  _onSaleChange() {
    if (this.sale) {
      this.salesLoaded = true;
      this.initialAmount = this.amount;
      this.initialValue = this.amount || this.editedSale.default;
    }
  }

  _exitEditMode() {
    this.isEditActive = false;
    this.onToggleFocus?.({ isFocused: false });
    this.$document.off('click', this._documentClickHandler);
  }

  _documentClickHandler = (e) => {
    if (!this.isEditActive) {
      return;
    }

    const target = angular.element(e.target);
    if (!target.closest(this.$element).length) {
      this.$scope.$apply(() => this.cancel());
    }
  };

  async submitSale() {
    this.saleForm.$setSubmitted();
    if (this.saleForm.$invalid || this.saveInProgress) {
      this.focus('focus');
      return;
    }

    if (this.saleForm.$dirty) {
      this.saveInProgress = true;
      try {
        this.editedSale = await this.onSaleSubmit({
          initialValue: this.initialValue,
          sale: this.editedSale,
        });

        this.initialAmount = this.editedSale.amount;
        this.initialValue = this.editedSale.amount || this.editedSale.default;
      } catch {
        //
      }
    }

    this.cancel();
    this.saveInProgress = false;
  }
}

export default {
  templateUrl: inlineSalesEditUrl,
  controller: InitialSalesEditCtrl,
  controllerAs: 'ctrl',
  bindings: {
    sale: '=',
    inactive: '<',
    onSaleSubmit: '&',
    onToggleFocus: '&',
    getEmptySale: '&',
  },
};
